import { useMutation, useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getAboutSection, addAboutSection, updateAboutSection } from 'api/auth.api';

export const useGetAboutSection = () => {
  return useQuery({
    queryKey: ['aboutSection'],
    queryFn: getAboutSection,
  });
};

export const useAddAboutSection = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addAboutSection,
    onSuccess: (res) => {
      toast({
        title: 'Content Added',
        description: res?.data?.message || 'Added successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
      onSuccess?.(res);
    },
    onError: (error) => {
      toast({
        title: 'Field to add content',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};

export const useUpdateAboutSection = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateAboutSection,
    onSuccess: (res) => {
      toast({
        title: 'Content Updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
      onSuccess?.(res);
    },
    onError: (error) => {
      toast({
        title: 'Failed to update content',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
